import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { AuthProvider } from "./Store/Auth/Auth.context";
import { UserProvider } from "./Store";
import { GraphqlProvider } from "./GraphQL";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <AuthProvider>
        <UserProvider>
          <GraphqlProvider>
            <App />
          </GraphqlProvider>
        </UserProvider>
      </AuthProvider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
